export default __webpack_public_path__ + "images/baba-compliant-logo.png?8a8523929f5eaba557969bc17a05485b";